import { ComponentIds, HierarchyUtils, SelectableComponent } from '@inter-ikea-core/core';
import { IncludedProductComponent, IncludedShelfComponent, NonBehaviorDeleteComponent, PlannerEcsSystem, PlannerProductComponent, ProductInfoComponent, ProductType, UnavailableProductComponent } from '@inter-ikea-storageone/range';
/**
 * System that handles the included shelves in the BILLY frames so they don't get marked as
 * unavailable if the market doesn't sell them as separate articles.
 */
export class IncludedShelfSystem extends PlannerEcsSystem {
    constructor(coreApi) {
        super(coreApi, 'IncludedShelfSystem', ComponentIds.IN_SCENE_COMPONENT_ID);
        this.coreApi = coreApi;
        this.entityManager = this.coreApi.getServices().entityManager;
        this.mandatoryComponents = [PlannerProductComponent.id];
    }
    onAdd(entity) {
        const parent = HierarchyUtils.parent(entity);
        if (this.coreApi.entities.isProductType(entity, ProductType.BILLY_SHELF) &&
            parent &&
            this.coreApi.entities.isProductType(parent, ProductType.BILLY_FRAME)) {
            this.addComponentToIncludedShelves(entity, parent);
        }
    }
    onUpdate() { }
    onRemove() { }
    addComponentToIncludedShelves(shelf, frame) {
        const frameDesign = frame.getComponent(ProductInfoComponent.id)?.design;
        const frameHeight = this.coreApi.entities.getEntityComSize(frame)?.height;
        const shelfDesign = shelf.getComponent(ProductInfoComponent.id)?.design;
        if (frameDesign !== shelfDesign) {
            return;
        }
        const includedShelves = HierarchyUtils.getDescendantsWithComponent(frame, IncludedShelfComponent.id);
        const nbrOfIncludedShelves = frameHeight === 2020 ? 4 : 2;
        if (includedShelves.length < nbrOfIncludedShelves) {
            shelf.addComponent(new IncludedShelfComponent());
            shelf.addComponent(new IncludedProductComponent());
            shelf.addComponent(new NonBehaviorDeleteComponent());
            if (shelf.hasComponent(UnavailableProductComponent.id)) {
                shelf.removeComponent(UnavailableProductComponent.id);
                shelf.removeComponent(ComponentIds.OUTLINED_COMPONENT_ID);
                shelf.addComponent(new SelectableComponent());
            }
        }
    }
}
//# sourceMappingURL=IncludedShelfSystem.js.map